import React, { useEffect, useState } from "react";
import { FlexRowBetween, Button, GenericDiv, Input } from "../Style";
import { useSelector } from "react-redux";
import { addAlpha } from "../others/Functions";
import FilterBar from "../others/FilterBar";
import Submit from "./Submit";
import FilledLoading from "../loader/FilledLoading";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { editArrival } from "../../../store/reducers/guestsReducer";
import GenericModal from "../modals/GenericModal";
import YesNoModal from "../modals/YesNoModal";

const GenericArivalConfirmation = ({
  heartColor,
  transportation,
  specialMsg,
  transportationDetails,
  specialMsgDetails,
  specialDishes,
  acceptLimit,
  isDemo,
  blessing,
  blessTitle,
  seuda,
  // gId,
  invK,
  token,
  separation,
  self,
  // uId,
}) => {
  const dispatch = useDispatch();
  let categories = [
    { id: "נגיע", name: "נגיע" },
    { id: "אולי", name: "אולי" },
    { id: "לא נוכל להגיע", name: "לא נוכל להגיע" },
  ];
  const [selfFullname, setFullname] = useState("");
  const [selfPhone, setPhone] = useState("");
  const [category, setCategory] = useState("נגיע");
  const [showAcceptForm, setShowAcceptForm] = useState(false);
  const [showMaybeForm, setShowMaybeForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [seudaQ, setSeudaQ] = useState(false);

  const handleSetShowAcceptForm = () => {
    setSeudaQ(false);
    setShowAcceptForm(true);
  };

  const handleDis = (notes) => {
    if (isDemo) {
      setSeudaQ(false);
      toast.success("הפעולה בוצעה בהצלחה");
    } else {
      setLoading(true);
      dispatch(
        editArrival(token, {
          accept: 0,
          notes,
          acceptWomen: 0,
          acceptMen: 0,
          ans: self ? "S" : "L",
          selfFullname,
          selfPhone,
          self,
          // uId,
        }),
      ).then((res) => {
        setLoading(false);
        if (!res.payload?.error) {
          toast.success("תודה רבה על תשובתך!");
          setSeudaQ(false);
          setDone(true);
        } else toast.error(res.payload?.error);
      });
    }
  };

  const handleSubmit = () => {
    // let isSelf = self;
    // let isOk = true;
    // let phone1 = selfPhone;
    // if (isSelf && !isDemo) {
    //   console.log("i am here2");

    //   if (phone1[0] === "0") phone1 = phone1.substring(1);
    //   phone1 = phone1.replaceAll("-", "");
    //   phone1 = phone1.replaceAll(/[^\d]/g, "");

    //   const regex = /^[5]{1}[0-9]{8}$/g;
    //   const validatePhone = phone1.match(regex);
    //   if (
    //     selfFullname.length < 1 ||
    //     selfFullname.length > 30 ||
    //     !validatePhone
    //   ) {
    //     isOk = false;
    //     toast.warning("נא למלא שם מלא (2-30 תווים) ומספר נייד ישראלי חוקי");
    //   } else setPhone(phone1);
    // }
    // if (isOk) {
    if (category === "אולי") setShowMaybeForm(true);
    else if (category === "נגיע") {
      if (seuda) setSeudaQ(true);
      else setShowAcceptForm(true);
    } else {
      if (isDemo) toast.success("הפעולה בוצעה בהצלחה");
      else handleDis("");
      setDone(true);
    }
    // }
  };

  const handleNoMaybe = () => {
    if (isDemo) toast.success("הפעולה בוצעה בהצלחה");
    else {
      setLoading(true);
      dispatch(
        editArrival(token, {
          accept: null,
          acceptWomen: null,
          acceptMen: null,
          notes: "לא יודעים, להמשיך לבדוק",
          ans: self ? "S" : "L",
          selfFullname,
          selfPhone,
          self,
          // uId,
        }),
      ).then((res) => {
        setLoading(false);
        if (!res.payload?.error) {
          toast.success("תודה רבה על תשובתך!");
        } else toast.error(res.payload?.error);
      });
    }
    setShowMaybeForm(false);
    setDone(true);
  };

  const handleYesMaybe = () => {
    if (isDemo) toast.success("הפעולה בוצעה בהצלחה");
    else {
      setLoading(true);
      dispatch(
        editArrival(token, {
          accept: 0,
          acceptWomen: 0,
          acceptMen: 0,
          notes: "לא לקחת בחשבון כרגע, יעדכנו בקישור במידה ויהיה שינוי",
          ans: self ? "S" : "L",
          selfFullname,
          selfPhone,
          self,
          // uId,
        }),
      ).then((res) => {
        setLoading(false);
        if (!res.payload?.error) {
          toast.success("תודה רבה על תשובתך!");
        } else toast.error(res.payload?.error);
      });
    }
    setShowMaybeForm(false);
    setDone(true);
  };
  // console.log("token?.length: ", token?.length);

  return (
    <>
      {!self || isDemo ? null : (
        <>
          <FlexRowBetween
            style={{
              width: "90%",
              margin: "0px auto",
              marginTop: "20px",
              background: `${addAlpha(heartColor, 0.3)}`,
              padding: "20px",
              borderRadius: "12px",
              gap: "12px",
            }}
          >
            <div style={{ position: "relative", width: "50%" }}>
              <Input
                value={selfFullname}
                style={{
                  padding: "12px 14px",
                  paddingRight: "14px",
                  borderRadius: "10px",
                  border: "1px solid rgba(0,0,0,0.08)",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                  background: "rgba(255,255,255,0.9)",
                  fontSize: "15px",
                  direction: "rtl",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                }}
                placeholder={"שם מלא"}
                onChange={(e) => setFullname(e.target.value)}
                onFocus={(e) => {
                  e.target.style.borderColor = heartColor;
                  e.target.style.boxShadow = `0 0 0 2px ${addAlpha(heartColor, 0.25)}`;
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "rgba(0,0,0,0.08)";
                  e.target.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
                }}
              />
            </div>
            <div style={{ position: "relative", width: "40%" }}>
              <Input
                value={selfPhone}
                type="tel"
                inputMode="numeric"
                style={{
                  padding: "12px 14px",
                  paddingRight: "14px",
                  borderRadius: "10px",
                  border: "1px solid rgba(0,0,0,0.08)",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                  background: "rgba(255,255,255,0.9)",
                  fontSize: "15px",
                  direction: "rtl",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                }}
                placeholder={"מס׳ נייד"}
                onChange={(e) => setPhone(e.target.value)}
                onFocus={(e) => {
                  e.target.style.borderColor = heartColor;
                  e.target.style.boxShadow = `0 0 0 2px ${addAlpha(heartColor, 0.25)}`;
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "rgba(0,0,0,0.08)";
                  e.target.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
                }}
              />
            </div>
          </FlexRowBetween>
        </>
      )}
      {done ? (
        <>
          <GenericDiv
            onClick={() => setDone(false)}
            style={{
              padding: "12px 40px",
              borderRadius: "999px",
              boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
              color: "white",
              position: "relative",
              fontWeight: "700",
              fontSize: "15px",
              background: heartColor,
              width: "min-content",
              margin: "0 auto",
              marginTop: "18px",
              cursor: "pointer",
              transition: "box-shadow 0.2s ease",
            }}
          >
            שליחה מחדש
          </GenericDiv>
        </>
      ) : (
        <>
          <FlexRowBetween
            style={{
              justifyContent: "center",
              marginTop: "10px",
              padding: "0 12px",
            }}
          >
            <FilterBar
              color={heartColor}
              padding={"10px 18px"}
              data={categories}
              setProperty={setCategory}
              property={category}
            />
          </FlexRowBetween>

          <FlexRowBetween
            style={{
              justifyContent: "center",
              marginTop: "16px",
              padding: "0 20px",
            }}
          >
            <GenericDiv
              id="bla"
              onClick={() => {
                if (!self) handleSubmit();
                else {
                  let isOk = true;
                  let phone1 = selfPhone;
                  if (self && !isDemo) {
                    if (phone1[0] === "0") phone1 = phone1.substring(1);
                    phone1 = phone1.replaceAll("-", "");
                    phone1 = phone1.replaceAll(/[^\d]/g, "");

                    const regex = /^[5]{1}[0-9]{8}$/g;
                    const validatePhone = phone1.match(regex);
                    if (
                      selfFullname.length < 2 ||
                      selfFullname.length > 30 ||
                      !validatePhone
                    ) {
                      isOk = false;
                      toast.warning(
                        "נא למלא שם מלא (2-30 תווים) ומספר נייד ישראלי חוקי",
                      );
                    } else setPhone(phone1);
                  }
                  if (isOk) handleSubmit();
                }
              }}
              className="animate__animated animate__pulse animate__infinite"
              style={{
                marginTop: "10px",
                padding: "14px 48px",
                borderRadius: "999px",
                boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
                color: "white",
                fontWeight: "700",
                fontSize: "16px",
                background: heartColor,
                border: "none",
                cursor: "pointer",
                transition: "box-shadow 0.2s ease, transform 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.2)";
                e.currentTarget.style.transform = "scale(1.02)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,0.15)";
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              {category == "נגיע" ? "לחצו כאן לבחירת כמות" : "שליחה"}
            </GenericDiv>
          </FlexRowBetween>
        </>
      )}

      {showMaybeForm && (
        <GenericModal
          init={setShowMaybeForm}
          div={
            <YesNoModal
              yesColor={heartColor}
              title={"שאלה"}
              body={
                "האם זה בסדר מבחינתך שנסמן כרגע שאינך מגיע/ה ובמידה ויהיה שינוי תוכל למלא תשובתך מחדש?"
              }
              no={handleNoMaybe}
              yes={handleYesMaybe}
              yesText={
                <div
                  style={{
                    width: "min-content",
                    height: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  כן, זה בסדר
                </div>
              }
              noText={
                <div
                  style={{
                    width: "min-content",
                    height: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  לא, תמשיכו לבדוק איתי
                </div>
              }
            />
          }
        />
      )}

      {showAcceptForm && (
        <GenericModal
          init={setShowAcceptForm}
          div={
            <Submit
              // gId={gId}
              token={token}
              setDone={setDone}
              isDemo={isDemo}
              init={setShowAcceptForm}
              transportation={transportation}
              specialMsg={specialMsg}
              transportationDetails={transportationDetails}
              specialMsgDetails={specialMsgDetails}
              specialDishes={specialDishes}
              acceptLimit={acceptLimit}
              blessing={blessing}
              blessTitle={blessTitle}
              heartColor={heartColor}
              separation={separation}
              selfFullname={selfFullname}
              selfPhone={selfPhone}
              self={self}
              // uId={uId}
            />
          }
        />
      )}

      {/* {loading && <FilledLoading />} */}

      {seudaQ && (
        <GenericModal
          init={setSeudaQ}
          div={
            <YesNoModal
              title={"סעודה"}
              body={"האם תישארו לסעודה?"}
              no={() => handleDis("יגיע אבל לא יישאר לסעודה")}
              yes={handleSetShowAcceptForm}
            />
          }
        />
      )}
    </>
  );
};

export default GenericArivalConfirmation;

{
  /* <FlexRowBetween style={{ justifyContent: "center" }}>
          <div style={{ fontSize: "14px", marginLeft: "1px" }}>כמה אתם</div>
          <div style={{ fontSize: "14px" }}>?</div>
        </FlexRowBetween> */
}
